/**
 * Firebase Hosting preview-channel host detection.
 *
 * Kept in step with ag-portal src/app/alliance-group/core/utils/firebase-preview-host.util.ts.
 * The pattern matches the channel ids this repo's preview workflow derives — see
 * .github/workflows/firebase-approved-master-preview.yml, which lowercases the branch's
 * TASKID-<digits> into the channel id, giving hosts like
 * taskid-3005--alliance-group-portal.web.app.
 */
const FIREBASE_PREVIEW_HOST_PATTERN = /^(taskid-\d+)--.+\.(web\.app|firebaseapp\.com)$/i;

export function isFirebasePreviewHost(hostname?: string): boolean {
  const resolvedHostname = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');

  return FIREBASE_PREVIEW_HOST_PATTERN.test(resolvedHostname);
}

export function getFirebasePreviewChannelId(hostname?: string): string | null {
  const resolvedHostname = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');
  const match = resolvedHostname.match(FIREBASE_PREVIEW_HOST_PATTERN);

  return match?.[1]?.toLowerCase() ?? null;
}
